import { render } from "./App1.vue?vue&type=template&id=751cc87f"
import script from "./App1.vue?vue&type=script&lang=js"
export * from "./App1.vue?vue&type=script&lang=js"

import "./App1.vue?vue&type=style&index=0&id=751cc87f&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__